import * as TemplateTypes from 'types/template.types';

class MenuFadeScaleTransition extends TemplateTypes.MenuTransition {
    constructor(config: TemplateTypes.BaseTransitionConfig){
        super(config, `
            .MenuFadeScaleTransition-enter-active,
            .MenuFadeScaleTransition-leave-active {
                transform: scale(1);
                transition: ${config.duration ?? 500}ms ease;
            }
            
            .MenuFadeScaleTransition-enter-from,
            .MenuFadeScaleTransition-leave-to {
                transform: scale(2);
                opacity: 0;
            }
        `);
    }
}

export default MenuFadeScaleTransition;